import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { BarChart3 } from "lucide-react";
import type { OverviewMonthCount } from "../../../types/dashboard";
import ChartBox from "./ChartBox";
import styles from "../Dashboard.module.scss";

export default function RegistrationsChart({
  months,
}: {
  months: OverviewMonthCount[];
}): JSX.Element {
  const hasData = (months || []).some((m) => Number(m.count) > 0);
  const chartData = (months || []).map((m) => ({
    ...m,
    short: (m.label || "").split(" ")[0],
  }));

  return (
    <section className={styles.panel}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitleWrap}>
          <span className={styles.panelGlyph}>
            <BarChart3 size={16} />
          </span>
          <div>
            <h3 className={styles.panelTitle}>Registrations By Month</h3>
            <p className={styles.panelKicker}>Last six months of roster activity</p>
          </div>
        </div>
      </div>
      {!hasData ? (
        <div className={styles.empty}>
          <p className="mb-0">No registrations in the last six months.</p>
        </div>
      ) : (
        <div className={styles.chartWrap}>
          <ChartBox height={250}>
            <BarChart data={chartData} margin={{ top: 12, right: 8, left: -18, bottom: 0 }}>
              <defs>
                <linearGradient id="lsRegFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#1670bf" />
                  <stop offset="100%" stopColor="#8ec5f8" />
                </linearGradient>
              </defs>
              <CartesianGrid stroke="#eef3f8" vertical={false} />
              <XAxis
                dataKey="short"
                tick={{ fontSize: 11, fill: "#5a5d76", fontWeight: 600 }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                allowDecimals={false}
                tick={{ fontSize: 11, fill: "#8a93a6" }}
                axisLine={false}
                tickLine={false}
              />
              <Tooltip
                cursor={{ fill: "rgba(111, 176, 249, 0.08)" }}
                formatter={(value: any) => [Number(value).toLocaleString(), "Registrations"]}
                labelFormatter={(_, payload) => payload?.[0]?.payload?.label || ""}
              />
              <Bar
                dataKey="count"
                fill="url(#lsRegFill)"
                radius={[8, 8, 4, 4]}
                maxBarSize={36}
                isAnimationActive={false}
              />
            </BarChart>
          </ChartBox>
        </div>
      )}
    </section>
  );
}
